import React from 'react'
import styled from 'styled-components'
import { Rating } from '../../components/Rating/Rating'
import { STYLES } from '../../static/style'
import { Badge } from '../../components/Badge'

type AcademicRatingBadgeProps = {
  title: string
  rating?: number
  style?: React.CSSProperties
}

const StyledAcademicRatingBadge = styled(Badge)``

const AcademicRatingBadge = ({
  title,
  style,
  rating,
}: AcademicRatingBadgeProps) => (
  <StyledAcademicRatingBadge
    style={style}
    titleBackgroundColor={STYLES.PRIMARY_COLOR}
    titleTextColor={STYLES.COLOR_BLACK}
    textBackgroundColor={STYLES.LIGHTER_PRIMARY_COLOR}
    title={title}
  >
    <Rating rating={rating} />
  </StyledAcademicRatingBadge>
)

export default AcademicRatingBadge
